export const GOOGLE_REVIEWS_URL = 'https://share.google/nVSXrytTMLnavENPo';
export const ANGI_URL =
  'https://www.angi.com/companylist/us/ut/south-jordan/preferred-service-inc-reviews-3646170.htm';
export const HOME_ADVISOR_URL =
  'https://www.homeadvisor.com/rated.PreferredServiceHeating.14625265.html';
export const FACEBOOK_URL =
  'https://www.facebook.com/p/Preferred-Service-Heating-cooling-and-caring-100066845790428/';
export const YELLOW_PAGES_URL =
  'https://www.yellowpages.com/south-jordan-ut/mip/preferred-service-heating-cooling-19376943';
export const BBB_URL =
  'https://www.bbb.org/us/ut/south-jordan/profile/heating-and-air-conditioning/preferred-service-heating-cooling-and-air-purity-inc-1126-22168762';

export const ONLINE_PROFILE_LINKS = [
  {
    label: 'Google',
    href: GOOGLE_REVIEWS_URL,
    ariaLabel: 'Open Preferred Service Google reviews in a new tab',
  },
  {
    label: 'Facebook',
    href: FACEBOOK_URL,
    ariaLabel: 'Open Preferred Service Facebook page in a new tab',
  },
  {
    label: 'BBB',
    href: BBB_URL,
    ariaLabel: 'Open Preferred Service BBB profile in a new tab',
  },
  {
    label: 'Yellow Pages',
    href: YELLOW_PAGES_URL,
    ariaLabel: 'Open Preferred Service Yellow Pages profile in a new tab',
  },
  {
    label: 'Angi',
    href: ANGI_URL,
    ariaLabel: 'Open Preferred Service Angi profile in a new tab',
  },
  {
    label: 'HomeAdvisor',
    href: HOME_ADVISOR_URL,
    ariaLabel: 'Open Preferred Service HomeAdvisor profile in a new tab',
  },
];
